import { Link } from "react-router-dom";
import { Activity } from "lucide-react";
import { CONDITION_CARDS } from "../../data/content";

export default function ConditionCards() {
  return (
    <section className="container-wide py-20">
      <div className="max-w-2xl">
        <div className="eyebrow mb-3">What brings you here today?</div>
        <h2 className="text-3xl md:text-5xl font-heading leading-[1.05]">
          Choose what best describes your concern.
        </h2>
        <p className="text-brand-ink2 mt-4">
          Every condition needs a tailored approach. Start here and we'll guide you to the right care pathway.
        </p>
      </div>
      <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {CONDITION_CARDS.map((c) => (
          <Link
            key={c.slug}
            to={`/conditions/${c.slug}`}
            data-testid={`condition-${c.slug}`}
            className="group card-soft p-5 hover:border-brand-blue/30 hover:shadow-[0_12px_40px_rgb(0,0,0,0.08)] transition-shadow"
          >
            <div className="w-10 h-10 rounded-xl bg-brand-cream text-brand-blue flex items-center justify-center mb-3">
              <Activity size={18} />
            </div>
            <div className="font-heading font-medium text-brand-ink group-hover:text-brand-blue">{c.title}</div>
            <div className="text-xs text-brand-ink2 mt-1">{c.short}</div>
          </Link>
        ))}
      </div>
    </section>
  );
}
